import type { FallbackRender } from "@sentry/react";
import { ErrorScreen } from "./ErrorScreen";

export const ErrorFallback: FallbackRender = () => <ErrorScreen />;
